module.exports = __webpack_public_path__ + "ee26cca897c89a44a19d534334764017.pdf";